import React, { memo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import {
  StyledTextField,
  StyledInputAdornment,
  StyledInputLabel,
} from "./StyledTextFeild";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import Ticon from "../../../assets/icons/i-icon.svg";

/**
 * Reusable TextField component
 * @param {*} param0
 * @returns
 */

const TextField = ({
  id,
  label,
  placeholder,
  type,
  show,
  isShow,
  value,
  onChange,
  onClick,
  onFocus,
  helperText,
  error,
  onBlur,
  height,
  InputProps,
  width,
  marginTop,
  onKeyPress,
  iconclick,
  disabled,
  ref = null,
  multiline = false,
  maxRows = 0,
  required = false,
  minRows = 0,
  labelCss = false,
  icon,
  noLabel = false,
  tooltip = false,
  tooltipText = "",
}) => {
  return (
    <>
      <StyledInputLabel noLabel={noLabel}>
        {label}
        {required && <span style={{color: "red"}}> * </span>}
        {tooltip && <Tooltip title={tooltipText} arrow placement='right'><img src={Ticon} alt='info' className='info-icon' /></Tooltip>}
      </StyledInputLabel>
      <StyledTextField
        id={id}
        multiline={multiline}
        maxRows={maxRows}
        minRows={minRows}
        disabled={disabled}
        placeholder={placeholder}
        type={show ? "text" : type}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onClick={onClick}
        onBlur={onBlur}
        width={width}
        labelCss = {labelCss}
        error={error ? true : false}
        helperText={error ? helperText : null}
        height={height}
        margintop={marginTop}
        onKeyPress={onKeyPress}
        isIcon={InputProps}
        ref={ref}
        onWheel={(e) => type === "number" && e.target.blur()}
        InputProps={{
          startAdornment: icon ? (
            <StyledInputAdornment position="start">{icon}</StyledInputAdornment>
          ) : null,
          endAdornment: (
            <StyledInputAdornment position="end">
              {type === "password" ? (
                <IconButton
                  onClick={() => isShow(!show)}
                  edge="end"
                  disabled={disabled}
                >
                  {show ? (
                    <VisibilityOutlined className="visible-icon" />
                  ) : (
                    <VisibilityOffOutlined className="visible-icon" />
                  )}
                </IconButton>
              ) : type === "actionInput" ? (
                <IconButton
                  onClick={iconclick}
                  edge="end"
                  disabled={disabled}
                  type="submit"
                >
                  {InputProps}
                </IconButton>
              ) : (
                InputProps
              )}
            </StyledInputAdornment>
          ),
        }}
      />
    </>
  );
};

export default memo(TextField);
